export const CREATE_ORDERS = "CREATE_ORDERS"
export const CREATE_ORDERS_SUCCESS = "CREATE_ORDERS_SUCCESS"

export const SEARCH_FEE_DELIVERY = "SEARCH_FEE_DELIVERY"
export const SEARCH_FEE_DELIVERY_SUCCESS = "SEARCH_FEE_DELIVERY_SUCCESS"

export const CREATE_OR_EDIT_ORDERS_API_ERROR = "CREATE_OR_EDIT_ORDERS_API_ERROR"
